export const SIMERA_FEE = 700;

export const MINIMUM_BASE_COMPENSATION = 450;

export const TENANT_DEFAULT_FEES: Record<string, number> = {
  simera: 700,
  interfell: 400,
};

export const getCurrentTenant = (): string => {
  if (typeof window === 'undefined') return 'simera';
  const hostnamePrefix = (
    window.CypressMock?.location?.hostname || window.location.hostname
  )
    .toLowerCase()
    .split('.')[0];
  switch (hostnamePrefix) {
    case 'stg-interfell':
    case 'dev-interfell':
    case 'interfell':
      return 'interfell';
    case 'dev-jobecam':
    case 'stg-jobecam':
    case 'jobecam':
      return 'jobecam';
    default:
      return 'simera';
  }
};

export const getTenantDefaultFee = (tenantName?: string | null) => {
  const fallback =
    TENANT_DEFAULT_FEES[getCurrentTenant()] ?? TENANT_DEFAULT_FEES.simera;
  if (!tenantName) return fallback;
  const key = tenantName.toLowerCase();
  return TENANT_DEFAULT_FEES[key] ?? fallback;
};
